module.exports = __webpack_public_path__ + "static/michelle1-d09e4bda54c2c4eadb93774c9f36b279.jpeg";